module.exports = __webpack_public_path__ + "img/team-12.1a18ab0b.jpg";